import { render } from "./MainValidation.vue?vue&type=template&id=f844b0e0&scoped=true"
import script from "./MainValidation.vue?vue&type=script&lang=js"
export * from "./MainValidation.vue?vue&type=script&lang=js"

import "./MainValidation.vue?vue&type=style&index=0&id=f844b0e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f844b0e0"]])

export default __exports__